// TODO: Test on production to determine the optimal threshold
export const DEVICE_MAP_MIN_ZOOM = import.meta.env.VITE_ENV === 'production' ? 5 : 3;
export const DEVICE_MAP_DEFAULT_ZOOM = 10;
export const DEVICE_MAP_DEBOUNCE_TIME_IN_MS = 1000;

export const FARMBOT_OFFICE_COORDS = { lat: -33.78287, lng: 151.19683 };
export const RANCHBOT_OFFICE_COORDS = { lat: 32.75272, lng: -97.33128 };
